module.exports = __webpack_public_path__ + "static/media/foto5.d6cd205a.png";